module.exports = __webpack_public_path__ + "img/running.b8a35275.svg";